export async function getKeywordDataApi(id) {
    const response = await fetch(`/api/v1/ai-prompts/${id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
    return response;
}
